// @ts-nocheck
/* eslint-disable */
import { store } from "~/state/store";
import SceneFeature from "../feature";
import SceneCoords from "~/scene/common/coords";

interface IBBox {
	min: SceneCoords;
	max: SceneCoords;
	empty: boolean;
}

export default class SceneGeometry extends SceneFeature {
	_bbox: IBBox;

	/**
	 * Vytvoreni geometrie.
	 *
	 * @param  {Object} type Typ geometrie - viz. zacatek souboru
	 * @param  {String|Number} [id] Volitelne ID
	 * @param  {SceneCoords} coords Souradnice geometrie
	 * @param  {Object} options
	 */
	constructor(scene, itemId, type, id, coords, options) {
		super(scene, itemId);

		this._type = type;
		this._id = id || Math.random();
		this._coords = coords;
		this._source = "";
		this._plainId = 0;
		this._closureType = ""; // jen pro uzavirky
		this._options = {
			minDist: 3
		};
		this._pixelsData = {
			pixels: [],
			posKey: "",
			sizeKey: ""
		};

		if (options instanceof Array) {
			this._options = [];
			for (let i = 0; i < options.length; i++) {
				this._options[i] = {};
				for (let key in options[i]) {
					this._options[i][key] = options[i][key];
				}
				this._options[i].minDist = 3;
			}
		} else {
			for (let key in options) {
				this._options[key] = options[key];
			}
		}

		this._bbox = {
			min: null,
			max: null,
			empty: true,
		};
		this._countBBox();
	}

	/**
	 * Informace ohledne entity ve scene.
	 *
	 * @return {Object}
	 */
	get featureInfo() {
		return {
			name: "SceneGeometry",
			type: "geometry"
		};
	}

	/**
	 * Souhrn vsech dat, ktere vyuziva visualiser pri vytvoreni.
	 *
	 * @return {Object}
	 */
	getCreateData() {
		let rd = super.getCreateData();

		rd.type = this._type;
		rd.id = this._id;
		rd.coords = this._coords;
		rd.options = this._options;
		rd.data = this._data;

		return rd;
	}
	/**
	 * Nastaveni parametru geometrie.
	 *
	 * @param {Object} options
	 */
	setOptions(options) {
		for (let p in options) { this._options[p] = options[p]; }

		this._onChange(this._scene.featureEvent("geometrySetOptions", true, true), arguments);
	}

	/**
	 * Vycisteni geometrie.
	 */
	clear() {
		this._bbox = {
			min: null,
			max: null,
			empty: true,
		};

		this._onChange(this._scene.featureEvent("geometryClear", true, true), arguments);
	}

	/**
	 * Nastaveni souradnic geometrie.
	 *
	 * @param {SceneCoords} coords
	 */
	setCoords(coords) {
		this._coords = coords;
		this._countBBox();

		this._countBBox();
		this._onChange(this._scene.featureEvent("geometrySetCoords", true, true), arguments);
	}

	/**
	 * ID geometrie.
	 *
	 * @return {Number}
	 */
	getId() {
		return this._id;
	}

	/**
	 * Typ geometrie.
	 *
	 * @return {Number}
	 */
	getType() {
		return this._type;
	}

	/**
	 * Souradnice geometrie.
	 *
	 * @return {SceneCoords}
	 */
	getCoords() {
		return this._coords;
	}

	/**
	 * Nastaveni zdroje.
	 *
	 * @param {String} source
	 */
	setSource(source) {
		this._source = source;
	}

	/**
	 * Ziskani zdroje.
	 *
	 * @return {String}
	 */
	getSource() {
		return this._source;
	}

	/**
	 * Nastaveni ID.
	 *
	 * @param {Number} plainId
	 */
	setPlainId(plainId) {
		this._plainId = plainId;
	}

	getClosureType() {
		return this._closureType;
	}

	setClosureType(type) {
		this._closureType = type;
	}

	/**
	 * Ziskani ID.
	 *
	 * @return {Number}
	 */
	getPlainId() {
		return this._plainId;
	}

	/**
	 * Ziskani pixelu geometrie.
	 *
	 * @return {Number}
	 */
	getPixels() {
		let size = this._scene.getSize();
		let sizeKey = size.x + "|" + size.y;
		const { longitude, latitude, zoom } = store.getState().map;
		let posKey = longitude + "|" + latitude + "|" + zoom;

		// cache
		if (sizeKey == this._pixelsData.sizeKey && posKey == this._pixelsData.posKey) {
			return this._pixelsData.pixels;
		}

		let minDist = this._options.minDist;
		let offset = size.clone().scale(0.5);
		let last = null;
		let result = [];
		let pixels = [];

		for (let i = 0; i < this._coords.length; i++) {
			let item = this._coords[i];

			if (item instanceof SceneCoords) { /* souradnice */
				item = this._scene.coordsToPixel(item);

				/* pozor - u elipsy a kruhu neni tato optimalizace zadouci */
				if (last && last.distance(item) <= minDist && this._type != this._scene.GEOMETRY.ELLIPSE && this._type != this._scene.GEOMETRY.CIRCLE) {
					if (this._type == this._scene.GEOMETRY.PATH) { /* pokud se jedna o PATH, musime odstranit vse k predchozimu pismenku vcetne */
						let index = result.length - 1;

						while (index && typeof(result[index]) != "string") { index--; }
						result.splice(index);
					}

					continue;
				}

				last = item.clone();
				pixels.push(last);
				item.plus(offset);
			}
			else if (item instanceof Array) { /* pole souradnic */
				last = null;

				let arr = [];

				for (let j = 0; j < item.length; j++) {
					const pixel = this._scene.coordsToPixel(item[j]).plus(offset);

					arr.push(pixel);
				}

				item = arr;
			}

			pixels.push(item);
		}

		// save to cachce
		this._pixelsData.sizeKey = sizeKey;
		this._pixelsData.posKey = posKey;
		this._pixelsData.pixels = pixels;

		return pixels;
	}

	getPath() {
		if (this._coords?.length) {
			let path = "M";
			const items = [];

			const pixels = this.getPixels();

			for (let index = 0; index < pixels.length; index++) {
				if (Array.isArray(pixels[index])) {
					items.push(pixels[index].map(pixel => `${pixel.x},${pixel.y}`).join(" "));
				}
			}

			path += items.join("Z M");
			path += "Z";

			return path;
		}

		return "";
	}

	setPath(path) {
		this._onChange(this._scene.featureEvent("geometrySetPath", true, true), arguments);
	}

	/**
	 * Volitelne nastaveni geometrie.
	 *
	 * @return {Object}
	 */
	getOptions() {
		return this._options;
	}

	/**
	 * Ziskani SVG nodu geometrie.
	 *
	 * @param {Function} cb Callback funkce
	 * @param {Object} [scope = null] Vuci jakemu scopu volat funkci
	 */
	getNodes(cb, scope = null) {
		this._onChange(this._scene.featureEvent("geometryGetNodes", true, true), arguments);
	}

	/**
	 * Ziskani SVG nodu geometrie - synchronni verze.
	 *
	 * @return {Array} pole s geometriemi
	 */
	getNodesSync() {
		return this._onChange(this._scene.featureEvent("geometryGetNodesSync", true, true), arguments);
	}

	/**
	 * Spocitani stredu a zoomu geometrie.
	 *
	 * @param  {Boolean} [usePadding] Pouzit padding?
	 * @return {Array}
	 */
	computeCenterZoom(usePadding) {
		let coords = [];

		for (let i = 0; i < this._coords.length; i++) {
			let item = this._coords[i];

			if (!(item instanceof Array)) { item = [item]; }

			for (let j = 0; j < item.length; j++) {
				let c = item[j];

				if (!(c instanceof SceneCoords)) { continue; }

				coords.push(c);
			}
		}

		return this._scene.computeCenterZoom(coords, usePadding);
	}

	getBBoxWgs84() {
		return this._bbox;
	}

	/**
	 * Ziskani BBOxu.
	 *
	 * @return {Object}
	 */
	getBBox() {
		let output = {
			x: 0,
			y: 0,
			width: 0,
			height: 0
		};

		if (!this._bbox.empty) {
			let minBB = this._scene.coordsToPixel(this._bbox.min);
			let maxBB = this._scene.coordsToPixel(this._bbox.max);
			let size = this._scene.getSize();

			output.x = Math.round(Math.min(minBB.x, maxBB.x) + size.x / 2);
			output.y = Math.round(Math.min(minBB.y, maxBB.y) + size.y / 2);
			output.width = Math.round(Math.abs(maxBB.x - minBB.x));
			output.height = Math.round(Math.abs(maxBB.y - minBB.y));
		}

		return output;
	}

	/**
	 * Je geometrie viditelna?
	 *
	 * @return {Boolean}
	 */
	isGeometryVisible() {
		// bbox style
		let mapSize = this._scene.getSize();
		let bbox = this.getBBox();
		let mapArea = {
			x: 0,
			y: 0,
			width: mapSize.x,
			height: mapSize.y
		};

		return (this._isIntersection(mapArea, bbox));
	}

	/**
	 * Nastal prusecik dvou bboxu.
	 * @param  {Object}  bbox1 BBOX 1
	 * @param  {Object}  bbox2 BBOX 2
	 * @return {Boolean}
	 * @private
	 */
	_isIntersection(bbox1, bbox2) {
		let ltx = Math.max(bbox1.x, bbox2.x);
		let lty = Math.max(bbox1.y, bbox2.y);
		let rbx = Math.min(bbox1.x + bbox1.width, bbox2.x + bbox2.width);
		let rby = Math.min(bbox1.y + bbox1.height, bbox2.y + bbox2.height);

		// sirka a vyska pruseciku musi byt vetsi jak 0
		let width = Math.abs(rbx - ltx);
		let height = Math.abs(rby - lty);

		if (ltx <= rbx && lty <= rby && width * height > 0) {
			return true;
		}
		else {
			return false;
		}
	}

	_countBBox() {
		let minX = Infinity;
		let minY = Infinity;
		let maxX = -Infinity;
		let maxY = -Infinity;

		this._bbox.min = null;
		this._bbox.max = null;
		this._bbox.empty = true;

		if (!this._coords || !this._coords.length) {
			return;
		}

		const coordsSource = Array.isArray(this._coords[0])
			? this._coords
			: [this._coords];

		for (const coordItems of coordsSource) {
			for (const coordItem of coordItems) {
				minX = Math.min(coordItem.x, minX);
				minY = Math.min(coordItem.y, minY);
				maxX = Math.max(coordItem.x, maxX);
				maxY = Math.max(coordItem.y, maxY);
			}
		}

		if (minX !== Infinity) {
			this._bbox.min = this._scene.coordsFromWGS84(minX, minY);
			this._bbox.max = this._scene.coordsFromWGS84(maxX, maxY);
			this._bbox.empty = false;
		}
	}
}
